var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icons-credit"},[_c('h5',[_vm._v(" Icons made by Freepik"),_c('v-icon',{attrs:{"x-small":"","color":"red","right":""}},[_vm._v(" mdi-heart ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }